import {Badge} from "@mantine/core";
import {Product} from "../types.ts";

export const FreeTrialBadge = ({record}: { record: Product }) => {

    const color = record.freeTrial ? 'green' : 'gray';
    const status = record.freeTrial ? 'Yes' : 'No';

    return <Badge color={color}>{status}</Badge>;
};

